import { render } from "./DisplayRecord.vue?vue&type=template&id=775c3ed6"
import script from "./DisplayRecord.vue?vue&type=script&lang=js"
export * from "./DisplayRecord.vue?vue&type=script&lang=js"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__